"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const superagent = require("superagent");
var TYPE_MAP;
(function (TYPE_MAP) {
    TYPE_MAP[TYPE_MAP["UINT8"] = 1] = "UINT8";
    TYPE_MAP[TYPE_MAP["UINT16"] = 2] = "UINT16";
    TYPE_MAP[TYPE_MAP["UINT32"] = 3] = "UINT32";
    TYPE_MAP[TYPE_MAP["UINT64"] = 4] = "UINT64";
    TYPE_MAP[TYPE_MAP["STRING"] = 5] = "STRING";
    TYPE_MAP[TYPE_MAP["VECTOR_STRING"] = 6] = "VECTOR_STRING";
    TYPE_MAP[TYPE_MAP["MAP_STRING"] = 7] = "MAP_STRING";
    TYPE_MAP[TYPE_MAP["VECTOR_STRUCT"] = 8] = "VECTOR_STRUCT";
})(TYPE_MAP || (TYPE_MAP = {}));
const TYPE_MAP_DEFAULT = {
    [TYPE_MAP.UINT8]: 0,
    [TYPE_MAP.UINT16]: 0,
    [TYPE_MAP.UINT32]: 0,
    [TYPE_MAP.UINT64]: 0,
    [TYPE_MAP.STRING]: '',
    [TYPE_MAP.VECTOR_STRING]: '',
    [TYPE_MAP.MAP_STRING]: '',
    [TYPE_MAP.VECTOR_STRUCT]: '',
};
function dateFormat2Day(date) {
    const Y = date.getFullYear();
    const M = date.getMonth() + 1;
    const D = date.getDate();
    return `${Y}-${M < 10 ? '0' + M : M}-${D < 10 ? '0' + D : D}`;
}
class BGField {
    constructor(key, val, type, seq) {
        this.key = key;
        this.val = val;
        this.type = type;
        this.seq = parseInt(seq, 10);
        if (type === TYPE_MAP.VECTOR_STRUCT && !Array.isArray(val)) {
            throw new Error('struct/map need param to be array');
        }
    }
}
class BGReport {
    constructor() {
        this.params = {};
        this.config = {
            uri: 26348,
            aid: 60,
            model: {
                act_id: { type: TYPE_MAP.UINT64, seq: 14596 },
                type: { type: TYPE_MAP.UINT16, seq: 14597 },
                pid: { type: TYPE_MAP.STRING, seq: 14598 },
                uid: { type: TYPE_MAP.UINT64, seq: 14599 },
                source: { type: TYPE_MAP.STRING, seq: 14600 },
                log_type: { type: TYPE_MAP.UINT16, seq: 14601 },
                log_action: { type: TYPE_MAP.STRING, seq: 14602 },
                log_event: { type: TYPE_MAP.STRING, seq: 14603 },
                log_content: { type: TYPE_MAP.STRING, seq: 14604 },
                country_code: { type: TYPE_MAP.STRING, seq: 14605 },
                device_id: { type: TYPE_MAP.STRING, seq: 14606 },
                os: { type: TYPE_MAP.STRING, seq: 14607 },
                url: { type: TYPE_MAP.STRING, seq: 14608 },
                time: { type: TYPE_MAP.UINT64, seq: 14609 },
                extra: { type: TYPE_MAP.MAP_STRING, seq: 14610 },
            },
        };
        const { uri, aid, model } = this.config;
        this.uri = String(uri);
        this.aid = String(aid);
        this.model = model;
    }
    processVal(val, type) {
        switch (type) {
            case TYPE_MAP.UINT8:
            case TYPE_MAP.UINT16:
            case TYPE_MAP.UINT32:
            case TYPE_MAP.UINT64: {
                val = parseInt(val, 10);
                break;
            }
            case TYPE_MAP.STRING: {
                val = '' + val;
                break;
            }
            case TYPE_MAP.VECTOR_STRING: {
                var tmp = [];
                if (Array.isArray(val)) {
                    for (var i = 0, len = val.length; i < len; i++) {
                        tmp.push(this.processVal(val[i], TYPE_MAP.STRING));
                    }
                    val = tmp;
                }
                else {
                    throw new Error('invalid data type of array');
                }
                break;
            }
            case TYPE_MAP.MAP_STRING: {
                var tmpMap = {}, seq = 1;
                // map的seq顺序实际上没什么效果，所以直接递增
                for (var k in val) {
                    if (val.hasOwnProperty(k)) {
                        tmpMap[k] = {
                            value: '' + val[k],
                            seq: seq,
                        };
                        seq++;
                    }
                }
                val = tmpMap;
                break;
            }
            case TYPE_MAP.VECTOR_STRUCT: {
                // json形式的上报，只支持一个分组，即[{ Field, Field}]，不支持[{ Field, Field}, { Field, Field}]，即数组只有一个元素
                var tmpStruct = {};
                for (var j in val) {
                    if (val.hasOwnProperty(j) && val[j] instanceof BGField) {
                        tmpStruct[val[j].key] = this.formatField(val[j]);
                    }
                }
                val = [tmpStruct];
                break;
            }
            default:
                console.error(val, type);
                throw new Error('invalid type');
        }
        return val;
    }
    formatField(field) {
        var obj;
        if (field instanceof BGField) {
            obj = {
                value: this.processVal(field.val, field.type),
                type: field.type,
                seq: field.seq,
            };
            return obj;
        }
        else {
            console.error(field);
            throw new Error('invalid field param');
        }
    }
    writeField(field) {
        if (field instanceof BGField) {
            this.params[field.key] = this.formatField(field);
        }
        else {
            console.error(field);
            throw new Error('invalid field param');
        }
    }
    setUrl(url) {
        BGReport.REPORT_URL = url;
    }
    getUrl() {
        return BGReport.REPORT_URL.replace('#URI#', this.uri).replace('#AID#', this.aid);
    }
    format(params) {
        let result = {};
        Object.keys(this.model).reduce((result, key) => {
            result[key] =
                params[key] || TYPE_MAP_DEFAULT[this.model[key].type];
            this.writeField(new BGField(key, result[key], this.model[key].type, this.model[key].seq));
            return result;
        }, result);
        return this.params;
    }
}
BGReport.TYPE_MAP = TYPE_MAP;
BGReport.REPORT_URL = 'http://support-json.like.video/json?uri=#URI#&aid=#AID#';
/**
 * 日志上报到ck Service
 */
class Log {
    constructor(options) {
        this.options = {
            name: '',
            uid: '',
        };
        this.options = options;
    }
    /**
     * 业务异常，需要立即排查
     * @example
     * this.service.log.error('上传cdn失败', {imageUrl: '', imageSiz: ''});
     *
     * @param {string} msg
     * @param {PlainObject} obj
     */
    error(msg, obj) {
        this.base(1, msg, obj);
    }
    /**
     * 程序异常，但不影响业务
     * @example
     * this.service.log.warn('压缩失败', {imageUrl: '', imageSiz: ''});
     *
     * @param {string} msg
     * @param {PlainObject} obj
     */
    warn(msg, obj) {
        this.base(2, msg, obj);
    }
    /**
     * 正常业务打点，报表使用
     * this.service.log.info('压缩成功', {imageUrl: '', imageSiz: ''});
     *
     * @param {string} msg
     * @param {PlainObject} obj
     */
    info(msg, obj) {
        this.base(3, msg, obj);
    }
    /**
     * 对象转换为string，方便入库查找
     *
     * @param {PlainObject} obj
     * @returns {string} a=1;b=2;
     */
    format(obj) {
        let obj2str = '';
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                obj2str += `${key}=${Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' ? JSON.stringify(obj[key]) : obj[key]};`;
            }
        }
        return obj2str;
    }
    base(type, msg, obj) {
        const content = this.format(obj);
        const time = Date.now();
        this.report(Object.assign({ uid: this.options.uid || 0, act_id: 0, type: 0, pid: '', country_code: '', os: '', url: '', device_id: '', extra: {}, source: this.options.name || 'nuxt', log_type: type, log_action: msg, log_event: '', log_content: content, time, day: dateFormat2Day(new Date()) }, obj));
    }
    report(log) {
        const reportObj = new BGReport();
        const data = reportObj.format(log);
        const url = reportObj.getUrl();
        superagent
            .post(url)
            .send(data)
            .end((err, res) => {
            if (err) {
                console.log(err);
                return;
            }
            if (res.status === 200) {
                // console.log('上报成功');
            }
        });
    }
}
exports.default = (ctx, inject) => {
    // Inject $hello(msg) in Vue, context and store.
    const name = 'bigo.tv';
    const log = new Log({ name });
    ctx.$log = log;
    inject('log', log);
};
//# sourceMappingURL=data:application/json;base64,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